import { Component, Input, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-dynamic-content-container',
  templateUrl: './dynamic-content-container.component.html',
  styleUrls: ['./dynamic-content-container.component.css']
})
export class DynamicContentContainerComponent {

  @Input() title: string = 'Contenido Dinámico';
  @Input() rawContent: string = '<p>No se ha proporcionado contenido HTML.</p>'; // Nuevo input para el string HTML
  sanitizedContent!: SafeHtml; // Para el HTML seguro

  constructor(private sanitizer: DomSanitizer) { } // Inyecta DomSanitizer

  ngOnInit(): void {
    // Sanitiza el HTML. Por defecto, DomSanitizer elimina scripts y atributos peligrosos.
    // Si necesitas permitir etiquetas <style>, necesitarías bypassSecurityTrustHtml,
    // pero eso es MUY RIESGOSO y no se recomienda para contenido de fuentes no confiables.
    this.rawContent = this.rawContent.replace(/&nbsp;/g, ' ');
    this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.rawContent) || '';
  }

  showAlert() {
    alert(`Hola desde: ${this.title}`);
  }


}
